// eslint-disable no-undef
/* eslint-disable no-restricted-globals */

import axios from 'axios'


const url = process.env.REACT_APP_API_URL 

self.addEventListener( 'message', ( { data: { pageID, data, accessToken } } ) => {
  axios.put( `${url}/pages/${pageID}`,data,{
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  } )
    .then( ( { data } ) => self.postMessage( data ) )
    .catch( err => console.log( err ) )
} )


// WEBPACK FOOTER //
// ./src/workers/pagesUpate.worker.js